import {
  IMAGE_ACTIVE,
  IMAGE_CONNECT,
  IMAGE_DELETED,
  IMAGE_DISCONNECT,
  IMAGE_GET,
  IMAGE_INACTIVE,
  IMAGE_RIGHTS_UPDATED
} from "../constants/actionTypes";
import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";

const defaultState = {
  title: "Vollbildmodus",
  hash: "",
  url: "",
  rights: 0,
  seniors: [],
  comments: []
};

export const imageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case IMAGE_ACTIVE:
      return {
        ...state,
        hash: action.payload.hash,
        url: action.payload.url,
        title: action.payload.title,
        rights: action.payload.rights,
        seniors: action.payload.seniors,
        comments: action.payload.comments
      };
    case IMAGE_CONNECT:
      return {
        ...state,
        seniors: [
          ...state.seniors,
          action.senior
        ]
      };
    case IMAGE_DISCONNECT:
      return {
        ...state,
        seniors: state.seniors.filter((senior) => senior !== action.senior)
      };
    case IMAGE_GET:
      return {
        ...state,
        hash: action.payload.hash,
        url: action.payload.url
      };
    case IMAGE_RIGHTS_UPDATED:
      return {
        ...state,
        rights: action.payload
      };
    case IMAGE_INACTIVE:
    case IMAGE_DELETED:
    case USER_LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};
